var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('PageLoader'),_c('Header',{on:{"searchInput":_vm.searchInputMethod}}),_c('router-view',{attrs:{"searchInputText":_vm.searchInput}}),_c('FooterTopArea'),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }